import { useState, useRef, useEffect } from "react";
import { supabase } from "./SupabaseClient";
import Login from "./Login.js";
import ExpenseList from "./ExpenseList";
import { useNavigate } from "react-router-dom";
const ExpenseForm = ({ passExpense, user }) => {
  const [description, setDescription] = useState("");
  const [amount, setAmount] = useState("");
  const [category, setCategory] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
  };
  const AddExpense = () => {
    if (!description || !category || !amount) return;

    passExpense({
      id: Date.now(),
      description,
      amount,
      category,
    });
    setDescription("");
    setAmount("");
    setCategory("");
  };
  const [username, setUsername] = useState("Guest");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getProfile = async () => {
      // 1. Get the currently logged-in user from Auth
      const {
        data: { user },
      } = await supabase.auth.getUser();

      if (user) {
        // 2. Fetch the username from your 'profiles' table where the ID matches
        const { data, error } = await supabase
          .from("profiles")
          .select("username")
          .eq("id", user.id)
          .single(); // We use .single() because there's only one profile per user

        if (data) {
          setUsername(data.username);
        }
        if (error) {
          console.error("Error fetching profile:", error.message);
        }
      }
      setLoading(false);
    };

    getProfile();
  }, []);
  const handleLogOut = async () => {
    const { data, error } = await supabase.auth.signOut();
    if (error) {
      alert("Failed to signout");
    } else {
      navigate("/Login");
    }
  };
  return (
    <main>
      <header>
        <h1>Expense Tracker</h1>
      </header>
      <section className="profile">
        <h2>Welcome: {loading ? "Loading..." : username}</h2>
        <button className="logout-btn" onClick={handleLogOut}>
          LogOut
        </button>
      </section>
      <form
        name="expense-form"
        class="form"
        autocomplete="off"
        onSubmit={handleSubmit}
      >
        <label htmlFor="description" name="description" />
        Description
        <input
          type="text"
          id="description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
        <label htmlFor="amount" name="amount" />
        Amount
        <input
          type="text"
          id="amount"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
        />
        <label htmlFor="category" name="category" />
        Category
        <input
          type="text"
          id="category"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
        />
      </form>
      <button type="button" onClick={AddExpense}>
        Add Expense
      </button>
    </main>
  );
};

export default ExpenseForm;
